/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserNamePipe } from './user-name.pipe';
import { PatientNamePipe } from './patient-name.pipe';
import { LocationPipe } from './location.pipe';
import { PhysicianNamePipe } from './physician-name.pipe';
import { DoctorNamePipe } from './doctor-name.pipe';
import { VerifiedTimerPipe } from './verified-timer.pipe';
import { WorkItemPipe } from './work-item.pipe';
import { TabsPipe } from './tabs.pipe';
import { EpochTimeAgoPipe } from './epoch-time-ago.pipe';
import { RadNamePipe } from './rad-name.pipe';
import { AgePipe } from './age.pipe';
import { DateTimePipe } from './date-time.pipe';
import { FormatNhiPipe } from './format-nhi.pipe';
import { TranslateNhiPipe } from '@app/common/pipes/translate-nhi.pipe';
import { FormatAgePipe } from './format-age.pipe';
import { LocalPatientNameDisplayPipe } from './local-patient-name-display.pipe';
import { MicroAppNotificationPipe } from './microapp-notification.pipe';

const pipes = [
  UserNamePipe,
  PatientNamePipe,
  LocationPipe,
  PhysicianNamePipe,
  DoctorNamePipe,
  VerifiedTimerPipe,
  WorkItemPipe,
  TabsPipe,
  EpochTimeAgoPipe,
  RadNamePipe,
  AgePipe,
  DateTimePipe,
  FormatNhiPipe,
  TranslateNhiPipe,
  FormatAgePipe,
  LocalPatientNameDisplayPipe,
  MicroAppNotificationPipe
];

@NgModule({
  declarations: pipes,
  exports: pipes,
  providers: pipes,
  imports: [CommonModule]
})
export class AppPipesModule {}
